module.exports = "<div v-bind:class=\"{repsonsive: responsive}\">\n\t<slot></slot>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/tables/tables.html
// module id = 73
// module chunks = 0